<div class="modal-overlay" *ngIf="isVisible" (click)="onBackdropClick($event)">
  <div class="customer-details-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Customer Details</h2>
        <button class="close-button" (click)="onClose()">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Customer Info Header -->
    <div class="customer-header" *ngIf="customer">
      <div class="customer-info-section">
        <div class="customer-basic-info">
          <div class="customer-avatar">
            <span class="avatar-initials"
              >{{ getInitials(customer.first_name || '')
              }}{{ getInitials(customer.last_name || '') }}</span
            >
          </div>
          <div class="customer-details">
            <div class="customer-name-row">
              <h3 class="customer-name">
                {{ customer.first_name || 'Unknown Customer' }} {{ customer.last_name || '' }}
              </h3>
              <!-- Vendor-imported customer (e.g. DRB via SiteWatch). Hidden for organic Way
                   customers (source null) and whenever that vendor's sync is turned off for
                   this shop — the customer and their membership stay untouched either way. -->
              <mat-chip
                *ngIf="showsVendorTag(customer.source)"
                class="chip-secondary vendor-source-tag"
                disableRipple
              >
                {{ customer.source || '' | uppercase }}
              </mat-chip>
            </div>
            <div class="status-toggle">
              <label class="switch">
                <input
                  type="checkbox"
                  [checked]="isCustomerActive"
                  (change)="onToggleChange($event)"
                  [disabled]="isUpdatingStatus"
                />
                <span class="slider round"></span>
              </label>
              <span class="status-label">{{ customer.customer_status | titlecase }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab View -->
    <div class="modal-content">
      <app-customer-tab-view
        [customer]="customer"
        (customerUpdated)="onCustomerUpdated()"
        (openCustomer)="openCustomer.emit($event)"
      >
      </app-customer-tab-view>
    </div>
  </div>

  <!-- Status Change Modals -->
  <app-customer-status-active-modal
    [isVisible]="showActiveModal"
    [isLoading]="isUpdatingStatus"
    (close)="onActiveModalClose()"
    (confirm)="onActiveModalConfirm()"
  >
  </app-customer-status-active-modal>

  <app-customer-status-inactive-modal
    [isVisible]="showInactiveModal"
    [isLoading]="isUpdatingStatus"
    (close)="onInactiveModalClose()"
    (confirm)="onInactiveModalConfirm()"
  >
  </app-customer-status-inactive-modal>
</div>
